module.exports = __webpack_public_path__ + "img/block.9e7a090f.png";